<template>
  <ul class="main-menu navbar-nav mr-auto">
    <!--
      "home"
      "lessons"
      "freebies"
      "audios"
      "materials"
      
      
    -->
    <li class="nav-item">
      <router-link
        :to="{ name: 'home' }"
        class="nav-link"
        @click.native="$emit('close')"
      >
        Início
      </router-link>
    </li>

    <b-nav-item-dropdown
      text="Sala de aula"
      right
      :toggle-class="dropdownClass('/sala-de-aula')"
    >
      <b-dropdown-item :to="{ name: 'lessons' }" @click.native="$emit('close')">
        Aulas
      </b-dropdown-item>
      <b-dropdown-item
        :to="{ name: 'freebies' }"
        @click.native="$emit('close')"
      >
        Conteúdo aberto
      </b-dropdown-item>

      <template v-if="$user.hasCof">
        <b-dropdown-item
          :to="{ name: 'audios' }"
          @click.native="$emit('close')"
        >
          Áudios
        </b-dropdown-item>
        <b-dropdown-item
          :to="{ name: 'materials' }"
          @click.native="$emit('close')"
        >
          Materiais de apoio
        </b-dropdown-item>
      </template>

      <template v-else>
        <b-dropdown-item @click.native="goToPlans">
          Áudios
        </b-dropdown-item>
        <b-dropdown-item @click.native="goToPlans">
          Materiais de apoio
        </b-dropdown-item>
      </template>
    </b-nav-item-dropdown>

    <b-nav-item-dropdown
      v-if="$user.hasCof"
      text="Assuntos"
      right
      :toggle-class="dropdownClass('/tags')"
    >
      <b-dropdown-item
        v-for="t in $user.user.tags"
        :key="t.slug"
        :to="{ name: 'tags', params: { tag: t.slug } }"
      >
        {{ t.name }}
      </b-dropdown-item>
    </b-nav-item-dropdown>

    <b-nav-item-dropdown
      text="Cursos"
      right
      :toggle-class="dropdownClass('/cursos')"
    >
      <b-dropdown-item
        :to="{ name: 'my-courses' }"
        @click.native="$emit('close')"
      >
        Meus cursos
      </b-dropdown-item>
      <b-dropdown-item :to="{ name: 'catalog' }" @click.native="$emit('close')">
        Catálogo
      </b-dropdown-item>
    </b-nav-item-dropdown>

    <li class="nav-item">
      <router-link
        :to="{ name: 'academics' }"
        class="nav-link"
        :class="{ 'router-link-exact-active': $route.name === 'academics' }"
        @click.native="$emit('close')"
      >
        Academia COF
      </router-link>
    </li>

    <li class="nav-item">
      <a
        href="https://seminariodefilosofia.zendesk.com/hc/pt-br/sections/360011679252-Perguntas-frequentes"
        target="_blank"
        class="nav-link"
        @click="$emit('close')"
      >
        FAQ
      </a>
    </li>

    <li class="nav-item d-lg-none">
      <router-link
        :to="{ name: 'account' }"
        class="nav-link"
        @click.native="$emit('close')"
      >
        Minha conta
      </router-link>
    </li>

    <!-- <li class="nav-item">
      <a
        href="javascript:openSupport()"
        class="nav-link"
        @click="$emit('close')"
      >
        SAC
      </a>
    </li> -->

    <li class="nav-item d-lg-none">
      <a class="nav-link" @click="$emit('logout')">Sair</a>
    </li>
  </ul>
</template>

<script>
export default {
  methods: {
    dropdownClass(basePath) {
      return this.$route.path.indexOf(basePath) === 0
        ? "router-link-exact-active"
        : "";
    },
    goToPlans() {
      this.$router.push({ name: "plans" });
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.main-menu {
  ::v-deep .dropdown-menu.show {
    @media screen and (max-width: 991px) {
      position: relative !important;
      transform: none !important;
      box-shadow: none !important;
    }
  }
}
</style>
